define(["exports", "react", "styled-components"], function (_exports, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.BeamerIcon = BeamerIcon;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var BeamerStyled = _styledComponents.default.span.withConfig({
    displayName: "BeamerIcon__BeamerStyled",
    componentId: "sc-wvfva6-0"
  })([".container-beamer{position:relative;#beamerButton{display:none;@media (min-width:64em){display:block;position:relative;.beamer_icon.active{left:13px;margin-top:10px;}}}}"]);

  function BeamerIcon() {
    return /*#__PURE__*/_react.default.createElement(BeamerStyled, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "container-beamer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "beamerButton"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "20",
      height: "19",
      viewBox: "0 0 20 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M18.664 0.478215L6 5.00022V12.0002L6.748 12.2672L5.621 14.5212C5.361 15.0402 5.34 15.6442 5.561 16.1802C5.784 16.7162 6.226 17.1292 6.777 17.3132L10.861 18.6742C11.066 18.7422 11.277 18.7752 11.485 18.7752C12.226 18.7752 12.936 18.3612 13.282 17.6712L14.585 15.0652L18.664 16.5222C19.314 16.7552 20 16.2722 20 15.5812V1.41922C20 0.728216 19.314 0.245215 18.664 0.478215ZM11.493 16.7772L7.41 15.4162L8.645 12.9452L12.687 14.3892L11.493 16.7772ZM2 12.0002H4V5.00022H2C0.897 5.00022 0 5.89722 0 7.00022V10.0002C0 11.1032 0.897 12.0002 2 12.0002Z",
      fill: "white"
    })))));
  }
});